import { CSSObject, GlobalStyles } from '@mui/material';
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

import './translations/translations'; // initialize i18n

const globalStyles: CSSObject = {
  body: {
    minWidth: 800,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif'
  }
};

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <GlobalStyles styles={globalStyles} />
    <App />
  </React.StrictMode>
);
